export interface EnterpriseFormVariables {
	firstName: number
	lastName: number
	companyName: number
	email: string
	message: string
}

export enum OptionType {
	ENTERPRISE = 'ENTERPRISE'
}

/**
 * Shape of `GET /clients/count`. The endpoint itself is still typed loosely for
 * its older callers, so consumers that need these fields narrow to this.
 */
export interface ClientCountResponse {
	currentClientNumber: number
	deletedClientsThisMonth: number
	maxClientsThisMonth: number
	// Advisory limit. Also mirrors `customMaxClientCount` when one exists, but on
	// its own it has never been enforced.
	maxClientNumber?: number
	// Hard client cap from the organization owner's negotiated flat-rate plan.
	// Resolved from the owner, so it applies to every member of the org.
	customMaxClientCount?: number | null
	tier1MaxClients: number
	tier1PricePerMonth: number
	tier2MinClients: number
	tier2PricePerAdditionalClient: number
	isAdminApproved: boolean
}

/** Which agreement a client limit came from. */
export type ClientLimitSource = 'negotiated' | 'whitelist'
